@if (scrollDirection != null) {
  <button class="jump-to-current-time-button"
    @fadeInScale
    (click)="onClick()"
    [attr.aria-label]="'transcript-viewer_jump-to-current-time' | translate"
    [matTooltip]="'transcript-viewer_jump-to-current-time' | translate">
    <i [class]="icon"></i>
  </button>
}
